"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ChatMenu;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const store_1 = require("../../store");
const user_1 = require("../../slices/user");
const conversation_1 = require("../../slices/conversation");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const ImageModels_1 = __importDefault(require("../AppCharacter/ImageModels"));
const AppText_1 = require("../AppText");
const character_1 = require("../../services/character");
const colors_1 = require("../../common/colors");
;
function ChatMenu({ character }) {
    const dispatch = (0, store_1.useAppDispatch)();
    const { request } = (0, useRequest_1.default)();
    const [isChangeStyleOpened, setIsChangeStyleOpened] = (0, react_1.useState)(false);
    const handleChangeStyle = (0, react_1.useCallback)((finalSelection) => {
        request(character_1.createEditCharacter, {
            id: character.id,
            characterName: character.characterName,
            background: character.background,
            styleString: finalSelection.imageModel?.styleString,
            imageModelId: finalSelection.modelId,
            aspectRatio: finalSelection.aspectRatio,
        }, true).then((characterResponse) => {
            if (characterResponse) {
                dispatch((0, user_1.setCharacter)(characterResponse.data));
            }
        });
    }, [character, request, dispatch]);
    const handleAutoPlayPress = (0, react_1.useCallback)(() => {
        dispatch((0, conversation_1.toogleAutoPlay)());
    }, [dispatch]);
    const handleChangeStylePress = (0, react_1.useCallback)(() => {
        setIsChangeStyleOpened(true);
    }, []);
    const handleChangeStyleClose = (0, react_1.useCallback)(() => {
        setIsChangeStyleOpened(false);
    }, []);
    const Trigger = (0, react_1.useCallback)((triggerProps) => ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { style: styles.triggerContainer, ...triggerProps, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faEllipsisVertical, size: 24, color: '#FFF' }) })), []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(native_base_1.Menu, { trigger: Trigger, placement: 'top right', style: styles.menu, children: [(0, jsx_runtime_1.jsx)(native_base_1.Menu.Item, { onPress: handleAutoPlayPress, style: styles.itemNormalized, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.item, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.iconWrapper, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faPlayCircle, size: 20, color: '#FFF' }) }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.text, children: "Autoplay" })] }) }), (0, jsx_runtime_1.jsx)(native_base_1.Menu.Item, { onPress: handleChangeStylePress, style: styles.itemNormalized, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.item, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.iconWrapper, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faImage, size: 20, color: '#FFF' }) }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.text, children: "Set Image Style" })] }) })] }), (0, jsx_runtime_1.jsx)(ImageModels_1.default, { isOpen: isChangeStyleOpened, showModelSelect: false, selectedStyle: character.styleString ?? '', selectedRatio: character.aspectRatio, onClose: handleChangeStyleClose, onSelect: handleChangeStyle })] }));
}
;
const styles = react_native_1.StyleSheet.create({
    triggerContainer: {
        padding: 4,
    },
    menu: {
        backgroundColor: '#26262C',
        padding: 0,
        borderRadius: 6,
    },
    itemNormalized: {
        backgroundColor: 'transparent',
        paddingHorizontal: 16,
        paddingVertical: 10,
        marginHorizontal: -12,
    },
    item: {
        gap: 10,
        flexDirection: 'row',
        alignItems: 'center',
    },
    iconWrapper: {
        padding: 2,
    },
    text: {
        color: colors_1.Colors.NEUTRAL_00,
        fontSize: 16,
    },
});
